<template>
	<div class="settings">
		<v-layout row wrap>
			<v-flex x12 sm12 md12 class="div-container-settings">
				<v-layout row wrap>
					<v-flex xs12 sm12 md12 class="div-container-title">
						<v-icon style="color: #3AE3EE !important" size="30">settings</v-icon>
						<p>Configuração Pessoal</p>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12 sm12 md12>
						<div class="cards-conclused" v-if="statusOfRegister == 3">
							<v-flex xs12 sm8 md5 class="box-cards-conclused">
								<p class="paragrafo-title-box-cards">Complete seu cadastro!</p>
								<p class="paragrafo-description">
									Precisamos das suas informações completas
									<strong> para realizar o pagamento</strong> das suas comissões!
								</p>
							</v-flex>
						</div>
						<div class="cards-conclused" style="background: #5191F2" v-if="statusOfRegister == 2">
							<v-flex xs12 sm8 md5 class="box-cards-conclused">
								<p class="paragrafo-title-box-cards">Cadastro passando por análise!</p>
								<p class="paragrafo-description">
									Caso os dados preenchidos estiverem todos corretos, o seu
									cadastro estará <strong>aprovado!</strong>
								</p>
							</v-flex>
						</div>
						<div class="cards-conclused" style="background: #41C58D" v-if="statusOfRegister == 1">
							<v-flex xs12 sm8 md5 class="box-cards-conclused">
								<p class="paragrafo-title-box-cards">Cadastro aprovado!</p>
								<p class="paragrafo-description">
									Agradecemos o seu cadastro completo, agora todo mês você terá seu
									<strong> pagamento </strong> no banco informado.
								</p>
							</v-flex>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12 sm12 md12 class="div-container-emails">
						<v-checkbox
							label="Receber e-mails de novas ações de marketing"
							v-model="notificationEmail"
						></v-checkbox>
					</v-flex>
				</v-layout>
				<v-form
					ref="form"
					v-model="valid"
					lazy-validation
				>
					<div class="div-container-informations-settings">
						<div class="div-layout-address">
							<p class="paragrago-title-address">Endereço</p>
							<div class="div-container-address">
								<div class="div-container-address-box-one">
									<v-text-field
										label="Rua"
										v-model="aff.address.street"
										return-masked-value
										outline
									></v-text-field>
									<v-text-field
										label="Bairro"
										v-model="aff.address.neighborhood"
										outline
									></v-text-field>
									<v-text-field
										label="Cidade"
										v-model="aff.address.city"
										outline
									></v-text-field>
									<v-text-field
										label="Complemento"
										v-model="aff.address.complement"
										outline
									></v-text-field>
									<v-text-field
										label="Telefone *"
										v-model="aff.address.phone"
										:rules="rules.required"
										mask="(##) #########"
										outline
									></v-text-field>
								</div>
								<div class="div-container-address-box-two">
										<v-text-field
											label="N.º"
											mask="######"
											v-model="aff.address.street_n"
											outline
										></v-text-field>
										<v-text-field
											return-masked-value
											label="CEP"
											mask="#####-###"
											v-model="aff.address.cep"
											@change="doGetAddressByCity"
											outline
										></v-text-field>
										<v-select
											:items="items"
											v-model="aff.address.state"
											label="UF"
											outline
										></v-select>
								</div>
							</div>
						</div>
						<div class="div-layout-bank">
							<p class="paragrafo-title-bank">Dados Bancários</p>
							<div class="div-container-bank">
								<div class="div-buttons-bank">
									<button
										:class="`${regType === 'fisica'}`"
										v-on:click="handleSubmitTypePerson('fisica', $event)"
									>
										Pessoa Física
									</button>
									<button
										v-if="validationOfbank === 'fisica'"
										:class="`${regType === 'juridica'}`"
										v-on:click="handleSubmitTypePerson('juridica', $event)"
										disabled
									>
										Pessoa Jurídica
									</button>
									<button
										v-else
										:class="`${regType === 'juridica'}`"
										v-on:click="handleSubmitTypePerson('juridica', $event)"
									>
										Pessoa Jurídica
									</button>
								</div>
								<v-text-field
									:label="regType == 'fisica' ? 'CPF *' : 'CNPJ *'"
									:rules="regType == 'fisica' ? rules.cpf : rules.cnpj"
									:mask="
										regType == 'fisica'
											? '###.###.###-##'
											: '##.###.###/####-##'
									"
									v-model="aff.bank_info.holder_doc"
									return-masked-value
									outline
								></v-text-field>
								<v-text-field
									label="Titular *"
									:rules="rules.required"
									v-model="aff.bank_info.holder_name"
									outline
								></v-text-field>
								<v-text-field
									label="Nome do Banco *"
									placeholder="Ex: Banco do Bradesco, Banco do Brasil, Itaú, ..."
									:rules="rules.required"
									v-model="aff.bank_info.bank_name"
									return-masked-value
									outline
								></v-text-field>
								<v-text-field
									label="Agência *"
									:rules="rules.required"
									mask="##########"
									v-model="aff.bank_info.office"
									outline
								></v-text-field>
								<v-text-field
									label="Conta *"
									:rules="rules.required"
									v-model="aff.bank_info.account"
									outline
								></v-text-field>
							</div>
							<div class="div-rodape-type-count">
								<p class="paragrafo-type-count">Tipo de Conta</p>
								<v-radio-group
									:rules="rules.required"
									row
									v-model="aff.bank_info.type"
								>
									<v-radio label="Poupança" color="#206c39" value="1"></v-radio>
									<v-radio label="Corrente" color="#206c39" value="2"></v-radio>
								</v-radio-group>
							</div>
						</div>
						<div class="div-layout-documentos" v-if="statusValidNumberPis">
							<p class="paragrafo-title-documentos">Documentos</p>
							<div class="div-container-documentos">
								<v-text-field
									label="Número do PIS *"
									v-model="numberOfPis"
									mask="###.#####.##-#"
									placeholder=""
									return-masked-value
									:rules="rules.validarPIS"
									outline
								></v-text-field>
								<v-text-field
									label="Data de Nascimento *"
									placeholder="DD/MM/YYYY"
									v-model="dataOfBirth"
									mask="##/##/####"
									return-masked-value
									:rules="rules.isValidDate"
									outline
								></v-text-field>
							</div>
						</div>
					</div>
					<div class="div-rodape-buttons-save">
						<v-layout row wrap>
							<v-flex xs12 sm12 md12 class="div-container-button-save">
								<button
									class="button-save-forms"
									v-if="statusValidNumberPis"
									v-on:click="handleSubmitForm"
								>
									Salvar
								</button>
								<button
									class="button-save-forms"
									v-else
									v-on:click="handleSubmitForm"
								>
									Salvar
								</button>
							</v-flex>
						</v-layout>
					</div>
				</v-form>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>

import { affiliate_api } from '@/api'
import validators from '@/utils/validators'

const emptyAffiliate = {
	address: {
		street: '',
		street_n: undefined,
		complement: '',
		neighborhood: '',
		cep: '',
		city: '',
		state: '',
		phone: '',
	},
	bank_info: {
		reg_type: 'fisica',
		holder_name: '',
		holder_doc: '',
		bank_name: '',
		office: '',
		account: '',
		type: '1',
	},
}

export default {
	name: 'Settings',
	mixins: [affiliate_api],
	data() {
		return {
			validationOfbank: '',
			dataOfBirth: '',
			numberOfPis: '',
			statusOfRegister: '',
			regType: 'fisica',
			notificationEmail: true,
			statusValidNumberPis: false,
			valid: true,
			aff: emptyAffiliate,
			rules: {
				isValidDate: validators.isValidDate,
				validarPIS: validators.validarPIS,
				cpf: validators.cpf,
				cnpj: validators.cnpj,
				required: validators.required,
			},
			items: [
				'AC',
				'AL',
				'AP',
				'AM',
				'BA',
				'CE',
				'DF',
				'ES',
				'GO',
				'MA',
				'MT',
				'MS',
				'MG',
				'PA',
				'PB',
				'PR',
				'PE',
				'PI',
				'RJ',
				'RN',
				'RS',
				'RO',
				'RR',
				'SC',
				'SP',
				'SE',
				'TO',
			],
		}
	},
	methods: {
		handleSubmitForm: async function(e) {
			e.preventDefault()
			if (!this.$refs.form.validate()) return

			try {

				const magauser = localStorage.getItem('magauser')

				const dados = {
					bank_info: {
						reg_type: this.regType,
						holder_doc: this.aff.bank_info.holder_doc,
						bank_name: this.aff.bank_info.bank_name,
						holder_name: this.aff.bank_info.holder_name,
						office: this.aff.bank_info.office,
						account: this.aff.bank_info.account,
						type: this.aff.bank_info.type,
					},
					address: {
						street: this.aff.address.street,
						complement: this.aff.address.complement,
						cep: this.aff.address.cep,
						city: this.aff.address.city,
						state: this.aff.address.state,
						neighborhood: this.aff.address.neighborhood,
						street_n: this.aff.address.street_n,
						phone: this.aff.address.phone,
					},
					numberPis: this.numberOfPis,
					dateBirth: this.dataOfBirth,
					statusOfRegister: 2,
				}

				this.statusOfRegister = 2

				await this.update_dados_affiliate(magauser, dados)

				this.$notify({
					type: 'success',
					title: 'Cadastro atualizado com sucesso!',
				})

			} catch (err) {
				this.$notify({
					type: 'error',
					title: 'Erro ao atualizar informações, informe a Magafilio!',
				})
			}
		},
		handleSubmitTypePerson: function(typePerson, event) {
			event.preventDefault()
			this.regType = typePerson
		},
		async doGetAddressByCity(cep) {
			const address = await this.getAddressByCep(cep)

			this.aff.address.neighborhood = address.bairro
			this.aff.address.street = address.logradouro
			this.aff.address.complement = address.complemento
			this.aff.address.city = address.localidade
			this.aff.address.state = address.uf
		},
		load_informations_user: async function() {
			const magauser = localStorage.getItem('magauser')

			const dados = await this.get_dados_affiliate(magauser)

			this.validationOfbank = dados.register.reg_type

			this.aff.address = {
				street: dados.address.street,
				street_n: dados.address.street_n,
				complement: dados.address.complement,
				cep: dados.address.cep,
				city: dados.address.city,
				state: dados.address.state,
				phone: dados.address.phone,
				neighborhood: dados.address.neighborhood
			}

			this.aff.bank_info = {
				holder_doc: dados.bank_info.holder_doc,
				bank_name: dados.bank_info.bank_name,
				holder_name: dados.bank_info.holder_name,
				office: dados.bank_info.office,
				account: dados.bank_info.account,
				type: dados.bank_info.type_account,
			}

			if (dados.register.reg_type === 'juridica') {
				this.regType = dados.bank_info.reg_type ? dados.bank_info.reg_type : 'juridica'
			} else if (dados.register.reg_type === 'fisica') {
				this.regType = dados.register.reg_type ? dados.register.reg_type : 'fisica'
			}

			this.dataOfBirth = dados.dateBirth
			this.numberOfPis = dados.numberPis
			this.statusOfRegister = dados.statusOfRegister

			this.statusValidNumberPis =
			dados.register.reg_type == 'fisica' ? true : false
		},
		post_notification_email: async function () {
			let magauser = localStorage.getItem('magauser')

			if (magauser) {
				this.response = await this.post_email_notification(
					magauser,
					this.notificationEmail
				)
			}

			return this.response
		},

		get_notification_email: async function () {
			let magauser = localStorage.getItem('magauser')

			if (magauser) {
				this.notification = await this.get_email_notification(magauser)
			}

			this.notificationEmail = this.notification.data
		},
	},
	created: async function() {
		this.load_informations_user()
		await this.get_notification_email()
	},
	watch: {
		statusOfRegister: function() {
			this.load_informations_user()
		},
		notificationEmail: async function () {
			await this.post_notification_email()
		},
	}
}
</script>

<style>

div.settings {
	margin: 55px 10px 95px 10px;
}

div.div-container-settings {
	margin-top: 25px;
	padding: 12px;
}

.div-container-settings .div-container-title {
	display: flex;
	align-items: center;
	justify-content: start;
	margin-bottom: 25px;
}

.div-container-settings .div-container-title i {
	margin-right: 10px;
}

.div-container-settings .div-container-title p {
	margin: 0px;
	font-size: 30px;
	font-weight: 500;
}

/* --- ESTILOS DOS CARDS DE STATUS --- */
div.cards-conclused {
	/* O background é aplicado via style inline, o que está OK */
	box-shadow: 0px 9px 16px rgba(0, 0, 0, 0.1); /* Sombra MODO CLARO */
	border-radius: 12px;
	display: flex;
	align-items: center;
	justify-content: center;
}
.theme--dark div.cards-conclused {
	box-shadow: 0px 9px 16px rgba(0, 0, 0, 0.25); /* Sombra MODO ESCURO */
}


div.cards-conclused .box-cards-conclused {
	padding: 12px 0px;
	text-align: center;
}

/* O texto escuro funciona bem nos fundos coloridos, mantido */
div.cards-conclused .box-cards-conclused p.paragrafo-title-box-cards {
	margin-bottom: 5px;
	color: rgba(45, 47, 50, 1) !important;
	font-size: 20px;
	font-weight: 800;
}

div.cards-conclused .box-cards-conclused p.paragrafo-description {
	margin-bottom: 0px;
	color: rgba(45, 47, 50, 1) !important;
	font-size: 13px;
}

div.cards-conclused .box-cards-conclused p.paragrafo-description strong {
	color: rgba(45, 47, 50, 1) !important;
}

/* --- ESTILOS DO CHECKBOX --- */
/* Esta regra já estava correta, apenas para o theme--light */
.div-container-emails .v-input--selection-controls__input .v-icon.material-icons.theme--light.accent--text {
	color: #40DA99 !important;
}

.div-container-emails .v-input.v-input--selection-controls.v-input--checkbox.theme--light .v-input__slot,
.div-container-emails .v-input.v-input--selection-controls.v-input--checkbox.v-input--is-label-active.v-input--is-dirty.theme--light .v-input__slot {
	padding: 4px 8px;
}

.div-container-emails .v-input.v-input--selection-controls.v-input--checkbox.theme--light .v-input__slot label.v-label.theme--light,
.div-container-emails .v-input.v-input--selection-controls.v-input--checkbox.v-input--is-label-active.v-input--is-dirty.theme--light .v-input__slot label.v-label.theme--light {
	margin-left: 5px;
}

.div-container-informations-settings {
	display: grid;
	grid-template-columns: 2fr 1fr;
	grid-column-gap: 30px;
}

/* --- ESTILOS DOS CONTAINERS DO FORMULÁRIO --- */
.div-layout-address,
.div-layout-bank,
.div-layout-documentos {
	border-radius: 23px;
	padding: 25px 30px 12px 30px;
	margin-top: 10px;
}

/* Estilos MODO CLARO (Inputs ficarão brancos sobre este fundo) */
.theme--light .div-layout-address,
.theme--light .div-layout-bank,
.theme--light .div-layout-documentos {
	background: #F5F5F5;
	box-shadow: 9px 9px 16px rgba(0, 0, 0, 0.1), -9px -9px 16px rgba(255, 255, 255, 1);
}

/* Estilos MODO ESCURO (Inputs ficarão escuros sobre este fundo) */
.theme--dark .div-layout-address,
.theme--dark .div-layout-bank,
.theme--dark .div-layout-documentos {
	background: #2D2F32;
	box-shadow: 9px 9px 16px rgba(0, 0, 0, 0.25), -9px -9px 16px rgba(74, 74, 74, 0.25);
}


.div-layout-address  p.paragrago-title-address {
	font-weight: 600;
	font-size: 18px;
	line-height: 23px;
	margin-bottom: 40px;
}

.div-container-address {
	display: grid;
	grid-template-columns: 2fr 1fr;
	grid-column-gap: 20px;
}

.div-layout-bank {
	/* background e shadow movidos para as regras de tema */
	margin-top: 25px;
	grid-column-start: 2;
	grid-column-end: 3;
	grid-row-start: 1;
	grid-row-end: 3;
}

.div-layout-bank  p.paragrafo-title-bank {
	font-weight: 600;
	font-size: 18px;
	line-height: 23px;
	margin-bottom: 40px;
}

.div-container-bank .div-buttons-bank {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 25px;
}

.div-container-bank .div-buttons-bank button {
	padding: 8px;
	font-weight: 400;
	font-size: 14px;
	line-height: 18px;
	/* O botão inativo usará a cor de texto padrão do tema */
}

/* Este estilo de botão ativo (verde) funciona bem em ambos os temas */
.div-container-bank .div-buttons-bank button.true {
	background: #40DA99;
	box-shadow: inset 2px 2px 4px rgba(0, 0, 0, 0.25), inset -2px -2px 4px rgba(255, 255, 255, 0.25);
	border-radius: 11px;
	padding: 8px 10px;
	color: rgba(45, 47, 50, 1) !important;
	font-weight: 600;
	font-size: 14px;
	line-height: 18px;
}

.div-rodape-type-count {
	margin-top: 25px;
}

.div-rodape-type-count p.paragrafo-type-count {
	font-size: 14px;
	line-height: 18px;
	font-weight: 500;
	margin-bottom: 40px;
}

.div-layout-documentos {
	/* background e shadow movidos para as regras de tema */
	margin-top: 25px;
}

.div-layout-documentos p.paragrafo-title-documentos {
	font-weight: 600;
	font-size: 18px;
	line-height: 23px;
	margin-bottom: 40px;
}

.div-container-documentos {
	display: grid;
	grid-template-columns: 2fr 1fr;
	grid-column-gap: 20px;
}

/* Begin input */
.v-text-field__slot {
	margin: 0px;
}

/* Cor do label focado (verde) - já estava OK */
.div-container-address .v-label.v-label--active.theme--light.primary--text,
.div-container-bank .v-label.v-label--active.theme--light.primary--text,
.div-container-documentos .v-label.v-label--active.theme--light.primary--text
{
	color: #40DA99 !important;
}

/* End input */


/* Begin select */

.div-container-address .v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections {
	padding: 5px !important;
}

.div-container-address .div-container-address-box-two .v-input__append-inner {
	margin-top: 10px !important;
}

.div-container-address .v-select__selection.v-select__selection--comma {
	margin-left: 15px !important;
}

.div-container-address .v-label.v-label--active.theme--light,
.div-container-bank .v-label.v-label--active.theme--light,
.div-container-documentos .v-label.v-label--active.theme--light
{
	opacity: 0.6 !important;
}

/* End select  */

/* --- ESTILOS DO BOTÃO SALVAR --- */

.div-rodape-buttons-save {
	margin-top: 45px;
}

.div-container-button-save {
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Estilo Base (MODO CLARO) */
.button-save-forms {
	background: #40DA99;
	box-sizing: border-box;
	box-shadow: -2px -2px 4px rgba(255, 255, 255, 1), 2px 2px 4px rgba(0, 0, 0, 0.1); /* Sombra MODO CLARO */
	border-radius: 24px;
	color: #2D2F32 !important; /* Texto escuro (OK nos dois modos) */
	padding: 8px 24px;
	font-size: 16px;
	font-weight: 500;
	transition: background 0.8s;
}

/* Override Sombra (MODO ESCURO) */
.theme--dark .button-save-forms {
	box-shadow: -2px -2px 4px rgba(74, 74, 74, 0.25), 2px 2px 4px rgba(0, 0, 0, 0.25); /* Sombra MODO ESCURO */
}

/* Hover (MODO CLARO) */
.theme--light .button-save-forms:hover {
	background: #F5F5F5;
}

/* Hover (MODO ESCURO) */
.theme--dark .button-save-forms:hover {
	background: #3a3c3f; /* Um pouco mais claro que o fundo */
}

/* End button save */

/* --- MEDIA QUERIES (Sem alteração) --- */
@media (max-width: 960px) {
	.div-container-informations-settings {
		display: flex;
		flex-direction: column;
	}
}

@media (max-width: 430px) {
	.div-container-informations-settings .div-container-address {
		display: flex;
		flex-direction: column;
	}

    .div-container-informations-settings .div-container-documentos {
		display: flex;
		flex-direction: column;
	}

    .div-container-settings .div-container-title p {
		font-size: 22px;
	}
}

@media (max-width: 280px) {
    .div-container-settings .div-container-title p {
		font-size: 18px;
	}
}

</style>
